// import React, { useState, useEffect } from 'react';
// import { BsBoxArrowRight, BsPersonCircle } from 'react-icons/bs';
// import { useNavigate } from 'react-router-dom';
// import A1 from '../Images/logo-w.png';

// const Dashboard = () => {
//     const [dropdownVisible, setDropdownVisible] = useState(false);
//     const [userData, setUserData] = useState(null);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUserData = JSON.parse(sessionStorage.getItem('user'));
//         if (storedUserData) {
//             setUserData(storedUserData);
//         } else {
//             navigate('/');
//         }
//     }, [navigate]);
//     const toggleDropdown = () => {
//         setDropdownVisible(!dropdownVisible);
//     };

//     const handleLogout = () => {
//         sessionStorage.removeItem('user');
//         sessionStorage.removeItem('userType');
//         navigate('/');
//         setDropdownVisible(false);
//     };

//     const handleAddItemClick = () => {
//         navigate('/itemmasterform-itemmasterform');
//     };

//     const handleAddItemClicks = () => {
//         navigate('/suppliermasterform-suppliermasterform');
//     };

//     const handlePurchaseIndentClick = () => {
//         navigate('/purchaseindentform-purchaseindentform');
//     };

//     const handlePurchaseOrderClick = () => {
//         navigate('/purchaseorder-purchaseorder');
//     };

//     return (
//         <div>
//             <div style={{ backgroundColor: "#dbc4a9" }}>
//                 <div className="container d-flex justify-content-between align-items-center">
//                     <img src={A1} alt="item" style={{ width: "20%" }} />
//                     <h2 className="mb-5 mt-5" style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>E-MEDHA ERP</h2>
//                     <div className="position-relative">
//                         <BsPersonCircle size={30} style={{ cursor: 'pointer' }} onClick={toggleDropdown} />
//                         {dropdownVisible && (
//                             <div style={{ position: 'absolute', right: '20px', top: '100%', backgroundColor: '#fff', zIndex: 1000, borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
//                                 <button
//                                     onClick={handleLogout}
//                                     style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', padding: '10px 15px', cursor: 'pointer', transition: 'background-color 0.3s', display: 'flex', alignItems: 'center' }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
//                                 >
//                                     <BsBoxArrowRight style={{ marginRight: '5px' }} />
//                                     Logout
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             {userData?.item_mst === "1" && (
//                 <div className="d-flex justify-content-center mt-5">
//                     <button className="btn btn-lg"
//                         onClick={handleAddItemClick}
//                         style={{ background: 'linear-gradient(145deg, #1e90ff, #4682b4)', border: 'none', color: '#fff', padding: '12px 24px', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)', fontWeight: 'bold', transition: 'transform 0.3s, box-shadow 0.3s', cursor: 'pointer' }}
//                         onMouseEnter={(e) => {
//                             e.currentTarget.style.transform = 'scale(1.05)';
//                             e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.currentTarget.style.transform = 'scale(1)';
//                             e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                         }}
//                     >
//                         ITEM MASTER
//                     </button>
//                 </div>
//             )}

//             {userData?.supp_mst === "1" && (
//                 <div className="d-flex justify-content-center mt-4">
//                     <button className="btn btn-lg"
//                         onClick={handleAddItemClicks}
//                         style={{ background: 'darkblue', border: 'none', color: '#fff', padding: '12px 24px', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)', fontWeight: 'bold', transition: 'transform 0.3s, box-shadow 0.3s', cursor: 'pointer' }}
//                         onMouseEnter={(e) => {
//                             e.currentTarget.style.transform = 'scale(1.05)';
//                             e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.currentTarget.style.transform = 'scale(1)';
//                             e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                         }}
//                     >
//                         SUPPLIER MASTER
//                     </button>
//                 </div>
//             )}

//             {/* New "PURCHASE INDENT" button */}
//             {userData?.purchase_int === "1" && (
//                 <div className="d-flex justify-content-center mt-4">
//                     <button className="btn btn-lg"
//                         onClick={handlePurchaseIndentClick}
//                         style={{ background: 'darkgreen', border: 'none', color: '#fff', padding: '12px 24px', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)', fontWeight: 'bold', transition: 'transform 0.3s, box-shadow 0.3s', cursor: 'pointer' }}
//                         onMouseEnter={(e) => {
//                             e.currentTarget.style.transform = 'scale(1.05)';
//                             e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.currentTarget.style.transform = 'scale(1)';
//                             e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                         }}
//                     >
//                         PURCHASE INDENT
//                     </button>
//                 </div>
//             )}

//             {/* New "PURCHASE ORDER" button */}
//             {userData?.purchase_int === "1" && (
//                 <div className="d-flex justify-content-center mt-4">
//                     <button className="btn btn-lg"
//                         onClick={handlePurchaseOrderClick}
//                         style={{ background: 'linear-gradient(145deg,rgb(31, 53, 76),rgb(62, 115, 157))', border: 'none', color: '#fff', padding: '12px 24px', borderRadius: '10px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)', fontWeight: 'bold', transition: 'transform 0.3s, box-shadow 0.3s', cursor: 'pointer' }}
//                         onMouseEnter={(e) => {
//                             e.currentTarget.style.transform = 'scale(1.05)';
//                             e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                         }}
//                         onMouseLeave={(e) => {
//                             e.currentTarget.style.transform = 'scale(1)';
//                             e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                         }}
//                     >
//                         PURCHASE ORDER
//                     </button>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default Dashboard;

// import React, { useState, useEffect } from 'react';
// import { BsBoxArrowRight, BsPersonCircle } from 'react-icons/bs';
// import { useNavigate } from 'react-router-dom';
// import A1 from '../Images/logo-w.png';

// const Dashboard = () => {
//     const [dropdownVisible, setDropdownVisible] = useState(false);
//     const [userData, setUserData] = useState(null);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUserData = JSON.parse(sessionStorage.getItem('user'));
//         if (storedUserData) {
//             setUserData(storedUserData);
//         } else {
//             navigate('/');
//         }
//     }, [navigate]);
//     const toggleDropdown = () => {
//         setDropdownVisible(!dropdownVisible);
//     };

//     const handleLogout = () => {
//         sessionStorage.removeItem('user');
//         sessionStorage.removeItem('userType');
//         navigate('/');
//         setDropdownVisible(false);
//     };

//     const handleAddItemClick = () => {
//         navigate('/itemmasterform-itemmasterform');
//     };

//     const handleAddItemClicks = () => {
//         navigate('/suppliermasterform-suppliermasterform');
//     };

//     const handlePurchaseIndentClick = () => {
//         navigate('/purchaseindentform-purchaseindentform');
//     };

//     const handlePurchaseOrderClick = () => {
//         navigate('/purchaseorder-purchaseorder');
//     };

//     const handleMaterialReceiptClick = () => {
//         navigate('/matirialreceipt-matirialreceipt');
//     };

//     const handleMaterialRequestClick = () => {
//         navigate('/material-request');
//     };
//     const handleMaterialIssuesClick = () => {
//         navigate('/material-issues');
//     };
//     const handlePIvsClick = () => {
//         navigate('/piVS');
//     };


//     const handlePOvsMRClick = () => {
//         navigate('/poVSmr');
//     };
//     const handlePOvsSuppClick = () => {
//         navigate('/poVSsupplier');
//     };


//     const handlePO_TC = () => {
//         navigate('/potc');
//     };
//     const [mastersOpen, setMastersOpen] = useState(false);
//     const [transactionsOpen, setTransactionsOpen] = useState(false);
//     const [reportsOpen, setReportsOpen] = useState(false);

//     const toggleMastersDropdown = () => setMastersOpen(!mastersOpen);
//     const toggleTransactionsDropdown = () => setTransactionsOpen(!transactionsOpen);
//     const toggleReportsDropdown = () => setReportsOpen(!reportsOpen);


//     // const sidebarStyle = {
//     //     width: '250px',

//     //     height: '100vh',
//     //     backgroundColor: '#dbc4a9',
//     //     paddingTop: '20px',
//     //     padding: '10px',
//     //     position: 'fixed',
//     //     left: '0',
//     //     top: '0',
//     //     display: 'flex',
//     //     flexDirection: 'column',
//     //     justifyContent: 'flex-start',
//     //     alignItems: 'flex-start',
//     //      overflowY: 'auto'
//     // };

//     const sidebarStyle = {
//         width: '250px',
//         height: '82vh',
//         backgroundColor: '#dbc4a9',
//         paddingTop: '20px',
//         padding: '10px',
//         // Remove position fixed so it doesn’t overlap
//         position: 'relative',
//         // Add margin-top to push the sidebar below the header

//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'flex-start',
//         alignItems: 'flex-start',
//         overflowY: 'auto'
//     };


//     const buttonStyle = {
//         width: '100%',
//         background: 'linear-gradient(145deg,rgb(232, 178, 143),rgb(139, 166, 188),rgb(116, 130, 197))',
//         border: 'none',
//         color: 'black',
//         padding: '12px 24px',
//         margin: '10px 0',
//         textAlign: 'left',
//         fontWeight: 'bold',
//         borderRadius: '5px',
//         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
//         cursor: 'pointer',
//         transition: 'transform 0.3s, box-shadow 0.3s',
//         fontSize: '16px',
//     };

//     const container = {
//         display: 'flex',
//         flexDirection: 'column', /* Stack the header, sidebar, and content vertically */
//     }
//     const containerr = {
//         display: 'flex',
//         flexDirection: 'row', /* Stack the header, sidebar, and content vertically */
//     }
//     const contentStyle = {
//         flex: 1, // This allows the content section to take up the remaining space
//         padding: '20px', // You can adjust this padding as needed
//     };


//     return (
//         <div style={container}>
//             <div style={{ backgroundColor: "#dbc4a9" }}>
//                 <div className="container d-flex justify-content-between align-items-center">
//                     <img src={A1} alt="item" style={{ width: "20%" }} />
//                     <h2 className="mb-5 mt-5" style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>E-MEDHA ERP</h2>
//                     <div className="position-relative">
//                         <BsPersonCircle size={30} style={{ cursor: 'pointer' }} onClick={toggleDropdown} />
//                         {dropdownVisible && (
//                             <div style={{ position: 'absolute', right: '20px', top: '100%', backgroundColor: '#fff', zIndex: 1000, borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
//                                 <button
//                                     onClick={handleLogout}
//                                     style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', padding: '10px 15px', cursor: 'pointer', transition: 'background-color 0.3s', display: 'flex', alignItems: 'center' }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
//                                 >
//                                     <BsBoxArrowRight style={{ marginRight: '5px' }} />
//                                     Logout
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 </div>



//             </div>


//             <div style={containerr}>
//                 <div style={sidebarStyle}>
//                     <button
//                         onClick={toggleMastersDropdown}

//                         style={{ backgroundColor: '#9ac9d1', width: '200px', transform: 'scale(1.05)', boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',margin:'10px' }} >
//                         Masters
//                     </button>
//                     {mastersOpen && (
//                         <>
//                             {userData?.item_mst === "1" && (
//                                 <button
//                                     style={buttonStyle}
//                                     onClick={handleAddItemClick}

//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     ITEM MASTER
//                                 </button>
//                             )}

//                             {userData?.supp_mst === "1" && (
//                                 <button
//                                     style={{ ...buttonStyle, backgroundColor: 'darkblue' }}
//                                     onClick={handleAddItemClicks}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     SUPPLIER MASTER
//                                 </button>
//                             )}

//                         </>
//                     )}
//                     <button
//                         onClick={toggleTransactionsDropdown}
//                         style={{ backgroundColor: '#9ac9d1', width: '200px', transform: 'scale(1.05)', boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',margin:'10px' }}>
//                         Transactions
//                     </button>
//                     {transactionsOpen && (
//                         <>
//                             {userData?.purchase_int === "1" && (
//                                 <button
//                                     style={{ ...buttonStyle, backgroundColor: 'darkgreen' }}
//                                     onClick={handlePurchaseIndentClick}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     PURCHASE INDENT
//                                 </button>
//                             )}

//                             {userData?.purchase_ord === "1" && (
//                                 <button
//                                     style={{ ...buttonStyle, backgroundColor: 'linear-gradient(145deg, rgb(31, 53, 76), rgb(62, 115, 157))' }}
//                                     onClick={handlePurchaseOrderClick}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     PURCHASE ORDER
//                                 </button>
//                             )}

//                             {userData?.material_recaipt === 1 && (
//                                 <button
//                                     style={{ ...buttonStyle, backgroundColor: 'linear-gradient(145deg, rgb(12, 12, 12), rgb(17, 121, 206))' }}
//                                     onClick={handleMaterialReceiptClick}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     MATERIAL RECEIPT
//                                 </button>
//                             )}

//                             {userData?.material_request === 1 && (
//                                 <button
//                                     style={{ ...buttonStyle, backgroundColor: 'linear-gradient(145deg, rgb(12, 12, 12), rgb(17, 121, 206))' }}
//                                     onClick={handleMaterialRequestClick}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     MATERIAL REQUEST
//                                 </button>
//                             )}

//                             {userData?.material_issues === 1 && (
//                                 <button
//                                     style={{ ...buttonStyle, backgroundColor: 'linear-gradient(145deg, rgb(12, 12, 12), rgb(17, 121, 206))' }}
//                                     onClick={handleMaterialIssuesClick}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     MATERIAL ISSUES
//                                 </button>

//                             )}
//                         </>
//                     )}
//                     <button
//                         onClick={toggleReportsDropdown}
//                         style={{ backgroundColor: '#9ac9d1', width: '200px', transform: 'scale(1.05)', boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)',margin:'10px' }}>
//                         Reports
//                     </button>
//                     {reportsOpen && (
//                         <>

//                                 <button
//                                     style={{ ...buttonStyle, backgroundColor: 'linear-gradient(145deg, rgb(12, 12, 12), rgb(17, 121, 206))' }}
//                                     onClick={handlePIvsClick}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }}
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     PI VS PO
//                                 </button>

//                                 <button
//                                     style={{ ...buttonStyle, backgroundColor: 'linear-gradient(145deg, rgb(12, 12, 12), rgb(17, 121, 206))' }}
//                                      onClick={handlePOvsMRClick}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }} 
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     PO VS MR
//                                 </button>



//                                 <button
//                                     style={{ ...buttonStyle, backgroundColor: 'linear-gradient(145deg, rgb(12, 12, 12), rgb(17, 121, 206))' }}
//                                      onClick={handlePO_TC}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }} 
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     PO _TC
//                                 </button>

//                                 <button
//                                     style={{ ...buttonStyle, backgroundColor: 'linear-gradient(145deg, rgb(12, 12, 12), rgb(17, 121, 206))' }}
//                                      onClick={handlePOvsSuppClick}
//                                     onMouseEnter={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1.05)';
//                                         e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                     }} 
//                                     onMouseLeave={(e) => {
//                                         e.currentTarget.style.transform = 'scale(1)';
//                                         e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                     }}
//                                 >
//                                     PO VS Supplier (PRINT)
//                                 </button>



//                         </>
//                     )}

//                 </div>


//                 <div style={contentStyle}>
//                     <div className="d-flex justify-content-center" >
//                         <div >

//                             <h3>Company Name : emedha Technologies </h3>
//                             <h3>EMP_ID       : 101</h3>
//                             <h3>Address:          </h3>
//                             <br></br>
//                             <img src="https://emedha.com/assets/img/logo.png" style={{ height: '150px' }} />
//                             <br></br>
//                             <h3>GST_NO: 37SGTYW32I00</h3>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//         </div>
//     );
// };

// export default Dashboard;

// import React, { useState, useEffect } from 'react';
// import { BsBoxArrowRight, BsPersonCircle } from 'react-icons/bs';
// import { useNavigate } from 'react-router-dom';
// import A1 from '../Images/logo-w.png';

// const Dashboard = () => {
//     const [dropdownVisible, setDropdownVisible] = useState(false);
//     const [userData, setUserData] = useState(null);
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUserData = JSON.parse(sessionStorage.getItem('user'));
//         if (storedUserData) {
//             setUserData(storedUserData);
//         } else {
//             navigate('/');
//         }
//     }, [navigate]);

//     const toggleDropdown = () => {
//         setDropdownVisible(!dropdownVisible);
//     };

//     const handleLogout = () => {
//         sessionStorage.removeItem('user');
//         sessionStorage.removeItem('userType');
//         navigate('/');
//         setDropdownVisible(false);
//     };

//     const navigateTo = (path) => {
//         navigate(path);
//     };

//     const [menuData, setMenuData] = useState([]);


//     const routeMap = {
//         '2001': '/purchaseindentform-purchaseindentform',
//         '2002': '/purchaseorder-purchaseorder',
//         '2003': '/matirialreceipt-matirialreceipt',
//         '2004': '/material-request',
//         '2005': '/material-issues',
//         '3001': '/piVS',
//         '3002': '/poVSmr',
//         '3003': '/poVSsupplier',
//         '3004': '/potc',
//         // Add more routes if necessary
//     };

//     // Fetch menu data from backend
//     useEffect(() => {
//         const fetchData = async () => {
//             const response = await fetch('https://erpapi.emedha.in/pages/api/api/menus'); // Your API endpoint
//             const data = await response.json();
//             setMenuData(data); // Set menu data from backend
//         };
//         fetchData();
//     }, []);

//     const handleNavigation = (routeId) => {
//         const route = routeMap[routeId];  // Get the route from routeMap using routeId
//         if (route) {
//             navigate(route);  // Navigate to the corresponding route
//         } else {
//             console.log('Route not found for:', routeId);
//         }
//     };




//     // const menuItems = [
//     //     {
//     //         title: 'Masters',
//     //         subItems: [
//     //             { title: 'ITEM MASTER', condition: userData?.item_mst === "1", path: '/itemmasterform-itemmasterform' },
//     //             { title: 'SUPPLIER MASTER', condition: userData?.supp_mst === "1", path: '/suppliermasterform-suppliermasterform' }
//     //         ]
//     //     },
//     //     {
//     //         title: 'Transactions',
//     //         subItems: [
//     //             { title: 'PURCHASE INDENT', condition: userData?.purchase_int === "1", path: '/purchaseindentform-purchaseindentform' },
//     //             { title: 'PURCHASE ORDER', condition: userData?.purchase_ord === "1", path: '/purchaseorder-purchaseorder' },
//     //             { title: 'MATERIAL RECEIPT', condition: userData?.material_recaipt === 1, path: '/matirialreceipt-matirialreceipt' },
//     //             { title: 'MATERIAL REQUEST', condition: userData?.material_request === 1, path: '/material-request' },
//     //             { title: 'MATERIAL ISSUES', condition: userData?.material_issues === 1, path: '/material-issues' }
//     //         ]
//     //     },
//     //     {
//     //         title: 'Reports',
//     //         subItems: [
//     //             { title: 'PI VS PO', condition: true, path: '/piVS' },
//     //             { title: 'PO VS MR', condition: true, path: '/poVSmr' },
//     //             { title: 'PO _TC', condition: true, path: '/potc' },
//     //             { title: 'PO VS Supplier (PRINT)', condition: true, path: '/poVSsupplier' }
//     //         ]
//     //     }
//     // ];

//     const [openMenus, setOpenMenus] = useState({});

//     const toggleMenu = (title) => {
//         setOpenMenus(prevState => ({
//             ...prevState,
//             [title]: !prevState[title]
//         }));
//     };

//     const sidebarStyle = {
//         width: '250px',
//         height: '82vh',
//         backgroundColor: '#dbc4a9',
//         paddingTop: '20px',
//         padding: '10px',
//         position: 'relative',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'flex-start',
//         alignItems: 'flex-start',
//         overflowY: 'auto'
//     };

//     const buttonStyle = {
//         width: '100%',
//         background: 'linear-gradient(145deg,rgb(232, 178, 143),rgb(139, 166, 188),rgb(116, 130, 197))',
//         border: 'none',
//         color: 'black',
//         padding: '12px 24px',
//         margin: '10px 0',
//         textAlign: 'left',
//         fontWeight: 'bold',
//         borderRadius: '5px',
//         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
//         cursor: 'pointer',
//         transition: 'transform 0.3s, box-shadow 0.3s',
//         fontSize: '16px',
//     };

//     const container = {
//         display: 'flex',
//         flexDirection: 'column', /* Stack the header, sidebar, and content vertically */
//     };
//     const containerr = {
//         display: 'flex',
//         flexDirection: 'row', /* Stack the header, sidebar, and content vertically */
//     };
//     const contentStyle = {
//         flex: 1, // This allows the content section to take up the remaining space
//         padding: '20px', // You can adjust this padding as needed
//     };

//     return (
//         <div style={container}>
//             <div style={{ backgroundColor: "#dbc4a9" }}>
//                 <div className="container d-flex justify-content-between align-items-center">
//                     <img src={A1} alt="item" style={{ width: "20%" }} />
//                     <h2 className="mb-5 mt-5" style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>E-MEDHA ERP</h2>
//                     <div className="position-relative">
//                         <BsPersonCircle size={30} style={{ cursor: 'pointer' }} onClick={toggleDropdown} />
//                         {dropdownVisible && (
//                             <div style={{ position: 'absolute', right: '20px', top: '100%', backgroundColor: '#fff', zIndex: 1000, borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
//                                 <button
//                                     onClick={handleLogout}
//                                     style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', padding: '10px 15px', cursor: 'pointer', transition: 'background-color 0.3s', display: 'flex', alignItems: 'center' }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
//                                 >
//                                     <BsBoxArrowRight style={{ marginRight: '5px' }} />
//                                     Logout
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             <div style={containerr}>
//                 <div style={sidebarStyle}>
//                     {menuData.map((menu, index) => (
//                         <div key={index}>
//                             <button
//                                 onClick={() => toggleMenu(menu.title)}
//                                 style={{ backgroundColor: '#9ac9d1', width: '200px', transform: 'scale(1.05)', boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)', margin: '10px' }}
//                             >
//                                 {menu.title}
//                             </button>
//                             {openMenus[menu.title] && menu.subItems.map((subItem, subIndex) => (
//                                 subItem.condition && (
//                                     <button
//                                     key={subIndex}
//                                         style={buttonStyle}
//                                         // onClick={() => navigateTo(item.path)}
//                                         onClick={() => handleNavigation(subItem.routeId)}  // Pass routeId to handleNavigation
//                                         onMouseEnter={(e) => {
//                                             e.currentTarget.style.transform = 'scale(1.05)';
//                                             e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                         }}
//                                         onMouseLeave={(e) => {
//                                             e.currentTarget.style.transform = 'scale(1)';
//                                             e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                         }}
//                                     >
//                                         {subItem.title}
//                                     </button>
//                                 )
//                             ))}
//                         </div>
//                     ))}
//                 </div>

//                 <div style={contentStyle}>
//                     <div className="d-flex justify-content-center">
//                         <div >
//                             <h3>Company Name: emedha Technologies</h3>
//                             <h3>EMP_ID: 101</h3>
//                             <h3>Address:</h3>
//                             <br />
//                             <img src="https://emedha.com/assets/img/logo.png" style={{ height: '150px' }} />
//                             <br />
//                             <h3>GST_NO: 37SGTYW32I00</h3>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//         </div>
//     );
// };

// export default Dashboard;



// import React, { useState, useEffect } from 'react';
// import { BsBoxArrowRight, BsPersonCircle } from 'react-icons/bs';
// import { useNavigate } from 'react-router-dom';
// import A1 from '../Images/logo-w.png';

// const Dashboard = () => {
//     const [dropdownVisible, setDropdownVisible] = useState(false);
//     const [userData, setUserData] = useState(null);
//     const [menuData, setMenuData] = useState([]); // Ensure it's an array
//     const navigate = useNavigate();

//     useEffect(() => {
//         const storedUserData = JSON.parse(sessionStorage.getItem('user'));
//         if (storedUserData) {
//             setUserData(storedUserData);
//         } else {
//             navigate('/');
//         }
//     }, [navigate]);
// console.log(userData)
//     const toggleDropdown = () => {
//         setDropdownVisible(!dropdownVisible);
//     };

//     const handleLogout = () => {
//         sessionStorage.removeItem('user');
//         sessionStorage.removeItem('userType');
//         navigate('/');
//         setDropdownVisible(false);
//     };

//     const navigateTo = (path) => {
//         navigate(path);
//     };

//     const routeMap = {
//         '1001': '/itemmasterform-itemmasterform',
//         '1002': '/suppliermasterform-suppliermasterform',
//         '2001': '/purchaseindentform-purchaseindentform',
//         '2002': '/purchaseorder-purchaseorder',
//         '2003': '/matirialreceipt-matirialreceipt',
//         '2004': '/material-request',
//         '2005': '/material-issues',
//         '3001': '/piVS',
//         '3002': '/poVSmr',
//         '3003': '/potc',
//         '3004': '/poVSsupplier',
//         '3005': '/stock',

//     };

//     // Fetch menu data from backend
//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await fetch('https://erpapi.emedha.in/pages/api/api/menus');
//                 const data = await response.json();
//                 console.log("Fetched menu data:", data); // Debugging step: Log the fetched data
//                 setMenuData(data || []); // In case data is undefined, default to empty array
//             } catch (error) {
//                 console.error("Error fetching menu data:", error);
//                 setMenuData([]); // Set to empty array if there's an error
//             }
//         };
//         fetchData();
//     }, []);

//     const handleNavigation = (routeId) => {
//         const route = routeMap[routeId];  // Get the route from routeMap using routeId
//         if (route) {
//             navigate(route);  // Navigate to the corresponding route
//         } else {
//             console.log('Route not found for:', routeId);
//         }
//     };

//     const [openMenus, setOpenMenus] = useState({});

//     const toggleMenu = (title) => {
//         setOpenMenus(prevState => ({
//             ...prevState,
//             [title]: !prevState[title]
//         }));
//     };

//     const sidebarStyle = {
//         width: '250px',
//         height: '82vh',
//         backgroundColor: '#dbc4a9',
//         paddingTop: '20px',
//         padding: '10px',
//         position: 'relative',
//         display: 'flex',
//         flexDirection: 'column',
//         justifyContent: 'flex-start',
//         alignItems: 'flex-start',
//         overflowY: 'auto'
//     };

//     const buttonStyle = {
//         width: '100%',
//         background: 'linear-gradient(145deg,rgb(232, 178, 143),rgb(139, 166, 188),rgb(116, 130, 197))',
//         border: 'none',
//         color: 'black',
//         padding: '12px 24px',
//         margin: '10px 0',
//         textAlign: 'left',
//         fontWeight: 'bold',
//         borderRadius: '5px',
//         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
//         cursor: 'pointer',
//         transition: 'transform 0.3s, box-shadow 0.3s',
//         fontSize: '16px',
//     };

//     const container = {
//         display: 'flex',
//         flexDirection: 'column',
//     };
//     const containerr = {
//         display: 'flex',
//         flexDirection: 'row',
//     };
//     const contentStyle = {
//         flex: 1,
//         padding: '20px',
//     };

//     return (
//         <div style={container}>
//             <div style={{ backgroundColor: "#dbc4a9" }}>
//                 <div className="container d-flex justify-content-between align-items-center">
//                     <img src={A1} alt="item" style={{ width: "20%" }} />
//                     <h2 className="mb-5 mt-5" style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>E-MEDHA ERP</h2>
//                     <div className="position-relative">
//                         <BsPersonCircle size={30} style={{ cursor: 'pointer' }} onClick={toggleDropdown} />
//                         {dropdownVisible && (
//                             <div style={{ position: 'absolute', right: '20px', top: '100%', backgroundColor: '#fff', zIndex: 1000, borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
//                                 <button
//                                     onClick={handleLogout}
//                                     style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', padding: '10px 15px', cursor: 'pointer', transition: 'background-color 0.3s', display: 'flex', alignItems: 'center' }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
//                                 >
//                                     <BsBoxArrowRight style={{ marginRight: '5px' }} />
//                                     Logout
//                                 </button>
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>

//             <div style={containerr}>
//                 <div style={sidebarStyle}>
//                     {/* Debugging step: Check if menuData is empty */}
//                     {menuData && menuData.length > 0 ? (
//                         menuData.map((menu, index) => (
//                             <div key={index}>
//                                 <button
//                                     onClick={() => toggleMenu(menu.heading)} // Toggle on heading
//                                     style={{ backgroundColor: '#9ac9d1', width: '200px', transform: 'scale(1.05)', boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)', margin: '10px' }}
//                                 >
//                                     {menu.heading}
//                                 </button>
//                                 {openMenus[menu.heading] && menu.subheadings && menu.subheadings.map((subItem, subIndex) => (
//                                     subItem.purpose && (
//                                         <button
//                                             key={subIndex}
//                                             style={buttonStyle}
//                                             onClick={() => handleNavigation(subItem.sub_id)} // Use sub_id for route
//                                             onMouseEnter={(e) => {
//                                                 e.currentTarget.style.transform = 'scale(1.05)';
//                                                 e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
//                                             }}
//                                             onMouseLeave={(e) => {
//                                                 e.currentTarget.style.transform = 'scale(1)';
//                                                 e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
//                                             }}
//                                         >
//                                             {subItem.purpose} {/* Display purpose */}
//                                         </button>
//                                     )
//                                 ))}
//                             </div>
//                         ))
//                     ) : (
//                         <p>Loading menu...</p>
//                     )}
//                 </div>

//                 <div style={contentStyle}>
//                     <div className="d-flex justify-content-center">
//                         <div >
//                             <h3>Company Name: emedha Technologies</h3>
//                             <h3>EMP_ID: 101</h3>
//                             <h3>Address:</h3>
//                             <br />
//                             <img src="https://emedha.com/assets/img/logo.png" style={{ height: '150px' }} />
//                             <br />
//                             <h3>GST_NO: 37SGTYW32I00</h3>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default Dashboard;



import React, { useState, useEffect } from 'react';
import { BsBorderWidth, BsBoxArrowRight, BsPersonCircle } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import A1 from '../Images/logo-w.png';
import axios from 'axios';
import { MdSettings } from "react-icons/md";
import { FaExchangeAlt, FaChartBar } from "react-icons/fa";
import {
    FaBox,
    FaTruck,
    FaClipboardList,
    FaFileInvoice,
    FaWarehouse,
    FaChartLine
} from "react-icons/fa";

import {
    MdInventory,
    MdAssignment,
    MdReceipt,
    MdRequestPage
} from "react-icons/md";
import { FiMenu, FiX } from "react-icons/fi";
import { BiTransferAlt } from "react-icons/bi";

const Dashboard = () => {
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [userData, setUserData] = useState(null);
    const [Emp_id, setEmpId] = useState(null);
    const [menuData, setMenuData] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const storedUserData = JSON.parse(sessionStorage.getItem('user'));
        if (storedUserData) {
            setUserData(storedUserData);

        } else {
            navigate('/');
        }
    }, [navigate]);


    // useEffect(() => {
    //     if (userData.Emp_id) {
    //         setEmpId(userData.Emp_id);
    //     }
    // }, [userData.Emp_id]);


    // useEffect(() => {
    //     console.log(Emp_id); // This will log the updated empId after it has been set
    // }, [Emp_id]);

    const toggleDropdown = () => {
        setDropdownVisible(!dropdownVisible);
    };

    const handleLogout = () => {
        sessionStorage.removeItem('user');
        sessionStorage.removeItem('userType');
        navigate('/');
        setDropdownVisible(false);
    };

    const navigateTo = (path) => {
        navigate(path);
    };

    const routeMap = {
        '1001': '/itemmasterform-itemmasterform',
        '1002': '/suppliermasterform-suppliermasterform',

        '2001': '/purchaseindentform-purchaseindentform',
        '2002': '/purchaseorder-purchaseorder',
        '2003': '/potc',
        '2004': '/matirialreceipt-matirialreceipt',
        '2005': '/material-request',
        '2006': '/material-issues',
        '2007': '/word_Order',
        '2008': '/word_Orderrec',

        '3001': '/piVS',
        '3002': '/poVSmr',
        '3003': '/poVSsupplier',
        '3004': '/stock',
        '3005': '/workOrderReport',
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('https://erpapi.emedha.in/pages/api/api/menus');
                const data = await response.json();
                console.log("Fetched menu data:", data);
                setMenuData(data || []); // In case data is undefined, default to empty array
            } catch (error) {
                console.error("Error fetching menu data:", error);
                setMenuData([]); // Set to empty array if there's an error
            }
        };
        fetchData();
    }, []);

    const iconMap = {
        Masters: <MdSettings />,
        Transactions: <FaExchangeAlt />,
        Reports: <FaChartBar />,
    };


    const subIconMap = {
        "Items Master": <FaBox />,
        "Supplier Master": <FaTruck />,

        "Work Order": <MdAssignment />,
        "Purchase Indent": <FaClipboardList />,
        "Purchase Order": <FaFileInvoice />,
        "Material Receipt": <MdReceipt />,
        "Material Request": <MdRequestPage />,
        "Materila Issues": <BiTransferAlt />,
        "Work Order Rec": <MdInventory />,
        " PO _TC": <FaFileInvoice />,

        " PI VS PO": <FaChartLine />,
        "PO_Print": <FaFileInvoice />,
        " PO VS MR": <FaChartLine />,
        "Stock": <FaWarehouse />,
        "Work Order Report": <FaChartLine />,
    };


    const handleNavigation = (routeId) => {
        const route = routeMap[routeId];  // Get the route from routeMap using routeId
        if (route) {
            navigate(route);  // Navigate to the corresponding route
        } else {
            console.log('Route not found for:', routeId);
        }
    };

    const [openMenus, setOpenMenus] = useState({});

    const toggleMenu = (title) => {
        setOpenMenus(prevState => ({
            ...prevState,
            [title]: !prevState[title]
        }));
    };

    // Function to check if the user has permission for a specific sub_id
    const hasPermission = (subId) => {
        // Check if the user has permission for the specific subId in their permissions
        if (userData && userData.permissions) {
            const permissions = userData.permissions;
            for (let parentId in permissions) {
                if (permissions[parentId].sub_ids && permissions[parentId].sub_ids[subId]) {
                    return true; // User has permission for this subId
                }
            }
        }
        return false; // No permission for this subId
    };

    const sidebarStyle = {
        width: '250px',
        height: '82vh',
        backgroundColor: '#dbc4a9',
        paddingTop: '20px',
        padding: '10px',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',
        overflowY: 'auto'
    };

    const buttonStyle = {
        width: '100%',
        background: 'linear-gradient(145deg,rgb(232, 178, 143),rgb(139, 166, 188),rgb(116, 130, 197))',
        border: 'none',
        color: 'black',
        padding: '12px 24px',
        margin: '10px 0',
        textAlign: 'left',
        fontWeight: 'bold',
        borderRadius: '5px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
        cursor: 'pointer',
        transition: 'transform 0.3s, box-shadow 0.3s',
        fontSize: '16px',
    };

    const container = {
        display: 'flex',
        flexDirection: 'column',
    };
    const containerr = {
        display: 'flex',
        flexDirection: 'row',
    };
    const contentStyle = {
        flex: 1,
        padding: '20px',
    };

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [companyDataName, setCompanyDataName] = useState([]);
    const [companyDataGST, setCompanyDataGST] = useState([]);
    const [companyDataadd, setCompanyDataGSTadd] = useState([]);
    const [companyDatagstno, setCompanyDataGSTgst] = useState([]);

    useEffect(() => {
        const fetchCompanyData = async () => {
            try {
                const response = await axios.get(
                    "https://erpapi.emedha.in/pages/api/api/get-Company-data"
                );
                setCompanyDataName(response.data[0].name); // Set company data to state
                setCompanyDataGST(response.data[0].company_logo);
                setCompanyDataGSTadd(response.data[0].address);
                setCompanyDataGSTgst(response.data[0].GST_NO);

                setLoading(false);
            } catch (err) {
                setError("Error fetching company data");
                setLoading(false);
            }
        };

        fetchCompanyData();
    }, []);
    console.log(userData)

    const [isSidebarOpen, setIsSidebarOpen] = useState(true);
    return (
        <div style={container}>
            {/* <div style={{ backgroundColor: "#dbc4a9" }}>
                <div className="container d-flex justify-content-between align-items-center">
                    <img src={A1} alt="item" style={{ width: "20%" }} />
                    <h2 className="mb-5 mt-5" style={{ color: "darkblue", fontSize: "1.95rem", fontWeight: "1000", marginBottom: "1rem" }}>E-MEDHA ERP</h2>
                    <div className="position-relative">
                        <BsPersonCircle size={30} style={{ cursor: 'pointer' }} onClick={toggleDropdown} />
                        {dropdownVisible && (
                            <div style={{ position: 'absolute', right: '20px', top: '100%', backgroundColor: '#fff', zIndex: 1000, borderRadius: '5px', boxShadow: '0 2px 5px rgba(0,0,0,0.2)' }}>
                                <button
                                    onClick={handleLogout}
                                    style={{ backgroundColor: '#007bff', color: '#fff', border: 'none', borderRadius: '5px', padding: '10px 15px', cursor: 'pointer', transition: 'background-color 0.3s', display: 'flex', alignItems: 'center' }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#0056b3'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#007bff'}
                                >
                                    <BsBoxArrowRight style={{ marginRight: '5px' }} />
                                    Logout
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div> */}
            <div style={{
                background: "#f8fafc",
                borderBottom: "1px solid #e5e7eb",
                padding: "10px 30px"
            }}>

                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>

                    {/* LEFT SIDE (LOGO + TITLE) */}
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px"
                    }}>
                        {/* <div style={{
                            width: "55px",
                            height: "55px",
                            background: "#020617",
                            borderRadius: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "relative",
                            boxShadow: "0 10px 20px rgba(0,0,0,0.2)"
                        }}>
                           

                            <div style={{
                                position: "absolute",
                                bottom: "-4px",
                                right: "-4px",
                                width: "14px",
                                height: "14px",
                                background: "#3b82f6",
                                borderRadius: "4px",
                                border: "2px solid white"
                            }} />
                        </div> */}

                        <div>
                            {/* <h2 style={{
                                margin: 0,
                                fontWeight: "900",
                                fontSize: "22px",
                                letterSpacing: "1px",
                                color: "#0f172a"
                            }}>
                                E-MEDHA <span style={{ color: "#2563eb" }}>ERP</span>
                            </h2>

                            <p style={{
                                margin: 0,
                                fontSize: "10px",
                                letterSpacing: "3px",
                                color: "#94a3b8"
                            }}>
                                INDUSTRIAL MANAGEMENT SYSTEM
                            </p> */}
                            <img src={A1} alt="logo" style={{ width: "20%" }} />
                        </div>
                    </div>

                    {/* RIGHT SIDE */}
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "15px"
                    }}>

                        {/* USER CARD */}
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            background: "#f1f5f9",
                            border: "1px solid #e2e8f0",
                            padding: "8px 12px",
                            borderRadius: "10px"
                        }}>
                            <div style={{
                                width: "35px",
                                height: "35px",
                                background: "#fff",
                                borderRadius: "8px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}>
                                <BsPersonCircle size={20} />
                            </div>

                            <div>
                                <div style={{
                                    fontSize: "9px",
                                    color: "#94a3b8",
                                    letterSpacing: "1px"
                                }}>
                                    OPERATOR
                                </div>
                                <div style={{
                                    fontWeight: "700",
                                    fontSize: "12px"
                                }}>
                                    EMP_ID: {userData ? userData.Emp_id : '...'}
                                </div>
                            </div>
                        </div>

                        {/* STATUS BADGE */}
                        {/* <div style={{
                            background: "#10b981",
                            color: "#fff",
                            padding: "8px 14px",
                            borderRadius: "10px",
                            fontSize: "11px",
                            fontWeight: "700",
                            boxShadow: "0 5px 15px rgba(16,185,129,0.3)"
                        }}>
                            SECURITY ACTIVE
                        </div> */}

                        {/* PROFILE DROPDOWN (UNCHANGED FUNCTIONALITY) */}
                        <div className="position-relative">
                            <BsPersonCircle
                                size={26}
                                style={{ cursor: 'pointer' }}
                                onClick={toggleDropdown}
                            />

                            {dropdownVisible && (
                                <div style={{
                                    position: 'absolute',
                                    right: 0,
                                    top: '40px',
                                    backgroundColor: '#fff',
                                    zIndex: 1000,
                                    borderRadius: '10px',
                                    boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                                    padding: "10px"
                                }}>
                                    <button
                                        onClick={handleLogout}
                                        style={{
                                            background: '#2563eb',
                                            color: '#fff',
                                            border: 'none',
                                            borderRadius: '6px',
                                            padding: '10px 15px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            fontWeight: "600"
                                        }}
                                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#1d4ed8'}
                                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
                                    >
                                        <BsBoxArrowRight style={{ marginRight: '6px' }} />
                                        Logout
                                    </button>
                                </div>
                            )}
                        </div>

                    </div>
                </div>
            </div>
            <div style={containerr}>
                {/* <div style={sidebarStyle}>
                    {menuData && menuData.length > 0 ? (
                        menuData.map((menu, index) => (
                            <div key={index}>
                                <button
                                    onClick={() => toggleMenu(menu.heading)} // Toggle on heading
                                    style={{ backgroundColor: '#9ac9d1', width: '200px', transform: 'scale(1.05)', boxShadow: '0 6px 12px rgba(0, 0, 0, 0.3)', margin: '10px' }}
                                >
                                    {menu.heading}
                                </button>
                                {openMenus[menu.heading] && menu.subheadings && menu.subheadings.map((subItem, subIndex) => (
                                    subItem.purpose && hasPermission(subItem.sub_id) && ( // Only show if user has permission
                                        <button
                                            key={subIndex}
                                            style={buttonStyle}
                                            onClick={() => handleNavigation(subItem.sub_id)} // Use sub_id for route
                                            onMouseEnter={(e) => {
                                                e.currentTarget.style.transform = 'scale(1.05)';
                                                e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.3)';
                                            }}
                                            onMouseLeave={(e) => {
                                                e.currentTarget.style.transform = 'scale(1)';
                                                e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.2)';
                                            }}
                                        >
                                            {subItem.purpose}
                                        </button>
                                    )
                                ))}
                            </div>
                        ))
                    ) : (
                        <p>Loading menu...</p>
                    )}
                </div> */}

                <div style={{
                    // width: isSidebarOpen ? "260px" : "80px",
                    // height: "82vh",
                    // background: "#ffffff",
                    // transition: "0.3s",
                    // padding: "10px",
                    // overflowY: "auto",
                    // color: "#fff",
                    // position: "relative",
                    // BsBorderWidth:"5px",
                    // borderColor:"black"
                    width: isSidebarOpen ? "260px" : "80px",
                    height: "82vh",
                    background: "#ffffff",
                    transition: "0.3s",
                    padding: "10px",
                    overflowY: "auto",
                    color: "#fff",
                    position: "relative",
                    border: "1px solid lightgray",
                }}>

                    {/* TOGGLE BUTTON */}
                    <div style={{
                        display: "flex",
                        justifyContent: isSidebarOpen ? "flex-end" : "center",
                        marginBottom: "10px"
                    }}>
                        <button
                            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                            style={{
                                background: "#fdfeff",
                                border: "none",
                                color: "#000000",
                                padding: "6px 10px",
                                borderRadius: "6px",
                                cursor: "pointer",
                                border: "1px solid black",
                            }}
                             title={isSidebarOpen ? "Close Sidebar" : "Open Sidebar"} // 👈 tooltip
                        >

                            {/* {isSidebarOpen ? "Close" : "Open"} */}
                             {isSidebarOpen ? <FiX size={18} /> : <FiMenu size={18} />}
                        </button>
                    </div>

                    {/* MENU */}
                    {menuData && menuData.length > 0 ? (
                        menuData.map((menu, index) => (
                            <div key={index} style={{ marginBottom: "10px" }}>

                                {/* MAIN MENU BUTTON */}
                                {/* <button
                    onClick={() => toggleMenu(menu.heading)}
                    style={{
                        width: "100%",
                        // background: "#1e293b",
                        // color: "#000000",
                        border: "none",
                        padding: "10px",
                        borderRadius: "8px",
                        textAlign: "left",
                        fontWeight: "600",
                        fontSize: "14px",
                        cursor: "pointer",
                        transition: "0.3s",
                        // border: "1px solid black",
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.background = "#e4e4e4"}
                    onMouseLeave={(e) => e.currentTarget.style.background = "#ffffff"}
                >
                    {isSidebarOpen ? menu.heading : "•"}
                </button> */}

                                <button
                                    onClick={() => toggleMenu(menu.heading)}
                                    style={{
                                        width: "100%",
                                        border: "none",
                                        padding: "10px",
                                        borderRadius: "8px",
                                        textAlign: "left",
                                        fontWeight: "600",
                                        fontSize: "14px",
                                        cursor: "pointer",
                                        transition: "0.3s",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "10px",
                                    }}
                                    onMouseEnter={(e) => (e.currentTarget.style.background = "#e4e4e4")}
                                    onMouseLeave={(e) => (e.currentTarget.style.background = "#ffffff")}
                                >
                                    {/* Show icon always */}
                                    {iconMap[menu.heading]}

                                    {/* Show text only when sidebar open */}
                                    {isSidebarOpen ? menu.heading : ""}
                                </button>

                                {/* SUB MENU */}
                                {isSidebarOpen && openMenus[menu.heading] &&
                                    menu.subheadings && menu.subheadings.map((subItem, subIndex) => (
                                        subItem.purpose && hasPermission(subItem.sub_id) && (
                                            <button
                                                key={subIndex}
                                                onClick={() => handleNavigation(subItem.sub_id)}
                                                style={{
                                                    width: "100%",
                                                    // background: "#020617",
                                                    // color: "#cbd5f5",
                                                    border: "none",
                                                    padding: "8px 12px",
                                                    marginTop: "6px",
                                                    borderRadius: "6px",
                                                    textAlign: "left",
                                                    fontSize: "13px",
                                                    cursor: "pointer",
                                                    transition: "0.3s",
                                                    alignItems: "center",
                                                    gap: "12px",
                                                    paddingLeft: "20px",

                                                }}
                                                onMouseEnter={(e) => {
                                                    e.currentTarget.style.background = "#e4e4e4";
                                                    e.currentTarget.style.color = "#000000";
                                                    e.currentTarget.style.transform = "translateX(5px)";
                                                    e.currentTarget.style.border = "1px solid black";
                                                }}
                                                onMouseLeave={(e) => {
                                                    e.currentTarget.style.background = "#f8f8f8";
                                                    e.currentTarget.style.color = "#000000";
                                                    e.currentTarget.style.transform = "translateX(0px)";
                                                    e.currentTarget.style.border = "0px solid white";
                                                }}
                                            >
                                                {/* Icon */}
                                                {/* {subIconMap[subItem.purpose] || <FaClipboardList />} */}

                                                <span style={{
                                                    minWidth: "18px", paddingRight: "20px",
                                                }}>
                                                    {subIconMap[subItem.purpose]}
                                                </span>

                                                {subItem.purpose}
                                            </button>
                                        )
                                    ))}

                            </div>
                        ))
                    ) : (
                        <p style={{ color: "#94a3b8", fontSize: "13px" }}>
                            Loading menu...
                        </p>
                    )}

                </div>
                {/* 
                <div style={contentStyle}>
                    <div className="d-flex justify-content-center">
                        <div >
                            <h3>{companyDataName}</h3>
                            <h3>EMP_ID: {userData ? userData.Emp_id : 'Loading...'}</h3>
                            <h3>Address: {companyDataadd}</h3>
                            <br />
                            <img src={companyDataGST} style={{ height: '150px' }} />
                            <br />
                            <h3>GST_NO: {companyDatagstno}</h3>
                        </div>
                    </div>
                </div> */}

                <div style={contentStyle}>
                    <div style={{
                        padding: "30px",
                        fontFamily: "sans-serif",
                        background: "#ffffff"
                    }}>

                        {/* TOP SMALL BAR */}
                        {/* <div style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "11px",
            color: "#6b7280",
            marginBottom: "20px"
        }}>
            <div>
                <b style={{ color: "#111827" }}>NETWORK:</b> OPERATIONAL
                <span style={{ margin: "0 10px" }}>|</span>
                <b style={{ color: "#111827" }}>SERVER:</b> ASIA-SOUTH-1
            </div>
            <div>v3.0.48-STABLE</div>
        </div> */}

                        {/* MAIN HEADER */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "flex-end",
                            borderBottom: "2px solid #111827",
                            paddingBottom: "20px",
                            marginTop:'0px'
                        }}>

                            {/* LEFT SIDE */}
                            <div style={{ display: "flex", gap: "20px" }}>

                                {/* LOGO BOX */}
                                <div 
                                style={{
                                    // width: "90px",
                                    // height: "90px",
                                    // background: "#020617",
                                    borderRadius: "16px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    // position: "relative"
                                }}>
                                    <img src={companyDataGST} style={{ width: "150px" }} />
                                    {/* <div style={{
                                        position: "absolute",
                                        bottom: "-5px",
                                        right: "-5px",
                                        width: "20px",
                                        height: "20px",
                                        background: "lightgreen",
                                        borderRadius: "6px"
                                    }} /> */}
                                </div>

                                {/* TITLE */}
                                <div>
                                    <h1 style={{
                                        fontSize: "42px",
                                        fontWeight: "900",
                                        margin: 0,
                                        lineHeight: "0.9"
                                    }}>
                                        {companyDataName || "COMPANY"} <br />
                                        {/* <span style={{ color: "#2563eb" }}>INDUSTRIES</span> */}
                                    </h1>

                                    {/* <p style={{
                        letterSpacing: "4px",
                        fontSize: "11px",
                        color: "#9ca3af",
                        marginTop: "10px"
                    }}>
                        ADVANCED POWER MONITORING SOLUTIONS
                    </p> */}

                                    {/* LOCATION + GST */}
                                    <div style={{
                                        display: "flex",
                                        gap: "30px",
                                        marginTop: "15px"
                                    }}>
                                        <div>
                                            <div style={{ fontSize: "10px", color: "#9ca3af" }}>
                                                FACILITY LOCATION
                                            </div>
                                            <div style={{ fontWeight: "600", fontSize: "13px" }}>
                                                {companyDataadd}
                                            </div>
                                        </div>

                                        <div>
                                            <div style={{ fontSize: "10px", color: "#9ca3af" }}>
                                                REGISTRY IDENTIFICATION
                                            </div>
                                            <div style={{ fontWeight: "600", fontSize: "13px" }}>
                                                GST: {companyDatagstno}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* RIGHT SIDE */}
                            <div style={{ textAlign: "right" }}>

                                {/* USER */}
                                <div style={{
                                    display: "inline-block",
                                    padding: "10px 15px",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "10px",
                                    marginBottom: "10px"
                                }}>
                                    <div style={{ fontSize: "10px", color: "#9ca3af" }}>
                                        OPERATOR
                                    </div>
                                    <div style={{ fontWeight: "700" }}>
                                        EMP_ID: {userData ? userData.Emp_id : 'Loading...'}
                                    </div>
                                </div>

                                {/* STATUS */}
                                <div style={{
                                    background: "#10b981",
                                    color: "#fff",
                                    padding: "10px 15px",
                                    borderRadius: "10px",
                                    fontWeight: "600",
                                    marginBottom: "10px"
                                }}>
                                    SECURITY ACTIVE
                                </div>

                                {/* LIVE BADGE */}
                                <div style={{
                                    background: "#020617",
                                    color: "#fff",
                                    padding: "8px 14px",
                                    borderRadius: "20px",
                                    fontSize: "11px"
                                }}>
                                    ● MONITORING SYSTEM LIVE
                                </div>

                            </div>
                        </div>

                        {/* BOTTOM BAR */}
                        <div style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: "25px"
                        }}>

                            {/* <div style={{ display: "flex", gap: "40px" }}>
                <div>
                    <div style={{ fontSize: "10px", color: "#9ca3af" }}>
                        DATA FEED
                    </div>
                    <div style={{ fontWeight: "700" }}>
                        ● REAL-TIME STREAMS
                    </div>
                </div>

                <div>
                    <div style={{ fontSize: "10px", color: "#9ca3af" }}>
                        GLOBAL AVERAGE
                    </div>
                    <div style={{ fontWeight: "700" }}>
                        415.8 <span style={{ color: "#9ca3af" }}>KWH</span>
                    </div>
                </div>
            </div> */}

                            {/* <button style={{
                background: "#020617",
                color: "#fff",
                padding: "12px 20px",
                border: "none",
                fontWeight: "700",
                letterSpacing: "1px",
                cursor: "pointer"
            }}>
                GENERATE REPORT
            </button> */}
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;